<div class="dashboard-continaer">
  <div class="welcome-name mb-2">
    <mwp-text-translate text="Welcome," jsonKey="welcome," />{{memberNameDisplay}}
  </div>
  <div class="card-container">
    <div class="content welcome-content mb-4">
      <mwp-text-translate text="Welcome to your employee benefits portal. You may navigate the site by using either the drop-down menus at the top of page or via the quick links provided on system pages, where available. The Benefits Dashboard is your starting point for all things benefits related. On this page you will find available enrollment sessions, an overview of existing benefits, pending benefit requests, payroll deduction amounts, and more. <b> Select Benefit Dashboard from the Benefits menu or click the Benefit Dashboard quick link to get started.</b>" [isHTML]="true" jsonKey="welcomeContentMessage" />
    </div>
  </div>
  <div class="mb-3">
    <mwp-in-page-nav [navItems]="navItems" />
  </div>
  <div class="row">
    <div class="ps-0" [ngClass]="isPayroll? 'col-5':'col-6'">
      @if (dashboardBanner) {
        <div class="external-image ps-3">
          <div (click)="bannerClick($event)" [innerHTML]="dashboardBanner | pipeSafeHTML"></div>
        </div>
      } @else {
        <div class="ps-3">
          <img src="../../../assets/images/Dasbhoard_Default.webp" class="w-100">
        </div>
      }
    </div>
    <div [ngClass]="isPayroll? 'col-7':'col-6'">
      <div class="row mb-3">
        @if(isPayroll)
        {
          <div class="col pe-3">
            <mwp-dashboard-boxes [labelOne]="boxOneLabel" [labelTwo]="boxTwoLabel" [amountOne]="boxOneValue" [amountTwo]="boxTwoValue" [fullHeight]="true" />
          </div>
        }
        <div class="col">
          <div class="content-container">
            <div class="title">
              <mwp-text-translate text="Basic Profile Info" jsonKey="basicProfileInfo" />
            </div>
            <div class="content">
              <div class="row mb-3">
                <div class="col-6">
                  <div>
                    <mwp-text-translate text="Email" jsonKey="email" />
                  </div>
                  <div class="fw-bold text-break">
                    {{email}}
                  </div>
                </div>
                <div class="col-6">
                  <div>
                    <mwp-text-translate text="System ID" jsonKey="systemID" />
                  </div>
                  <div class="fw-bold text-break">
                    {{systemNumber}}
                  </div>
                </div>
              </div>
              <div class="row pb-3">
                <div class="col-6">
                  <div>
                    <mwp-text-translate text="Company" jsonKey="company" />
                  </div>
                  <div class="fw-bold text-break">
                    {{companyName}}
                  </div>
                </div>
                <div class="col-6">
                  <div>
                    {{divisionCaption}}
                  </div>
                  <div class="fw-bold text-break">
                    {{division}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="content-container">
            <div class="title">
              <mwp-text-translate text="Message Center" jsonKey="messageCenter" />
            </div>
            <div class="content pb-3">
              @if ( !messageCenter || messageCenter.length == 0)
              {
                <div class="w-100 d-flex justify-content-center">
                  <mwp-text-translate text="No New Messages" jsonKey="noNewMessages" />
                </div>
              } @else {
                @for (message of messageCenter; track $index ) {
                  <div class="message-center">
                    <div class="message-title">
                      @if (message.enableButton) {
                        <div class="message-title-link" (click)="messageCenterButtonClick(message)">
                          {{message.messageHeader}}
                        </div>
                      } @else {
                        <div>
                          {{message.messageHeader}}
                        </div>
                      }
                      <div>
                        {{message.alertDate}}
                      </div>
                    </div>
                    <div class="message-content">
                      <div>
                        {{message.message}}
                      </div>
                    </div>
                    @if (messageCenter.length > 1 && messageCenter.length - 1 > $index) {
                      <hr>
                    }
                  </div>
                }
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>